import { Link } from "react-router-dom";
import "./homecss/locationstabsingle.css";
import { Card } from "react-bootstrap";

//LocationsTabOnesingle  for sm screen and calls on LocationTwo.
const LocationsTabOnesingle = (props) => {
  // function eachBlc(valIndex) {
  //   props.blcIndex(valIndex);
  // }

  // replacing whitespace(%20) with (-) from loc name in url 
  function locNameFormatting(str) {
    if (str.indexOf(' ') >= 0) {
      return str.split(' ').join('-');
    }
    else {
      return str;
    }
  }

  return (
    <>

      {/* <Link to="/eachblc">
        <Card style={{width: '8rem', height: '3.5rem'}}>
          <Card.Body className="phoneloc">
            <p className="fix-center" onClick={(e) => eachBlc(props.locIndex)}>{props.blcs}</p>
          </Card.Body>
        </Card>
      </Link> */}

      <Link to={`/locations/${locNameFormatting(props.blcs)}`}>
        <Card style={{ width: '8rem', height: '3.5rem' }}>
          <Card.Body className="phoneloc">
            <p className="fix-center">{props.blcs}</p>
          </Card.Body>
        </Card>
      </Link>

    </>
  );
};

export default LocationsTabOnesingle;
